import { useEffect, useLayoutEffect } from 'react';
import { useNavTabs } from 'App/components/Navtabs';
import { useNavegate } from 'App/hooks';
import { IonPageStratus } from 'commons/components';
import { combineStatus } from 'commons/utils/combineStatus';
import { openWindow } from 'commons/utils/window';
import { useDevelopmentStoreHistory } from 'domains/Account/hooks';
import {
  useAdminLinks,
  useIsMobileDevice,
  useStoreStatus,
} from 'domains/Auth/hooks';
import useLogout from 'domains/Auth/pages/LogoutPage/useLogout';
import { CHECKOUT_ROUTES } from 'domains/Billing/Checkout/checkoutRoutes';
import { useStoreChurnedStatus } from 'domains/Billing/hooks';
import { AppLoading } from 'domains/PartnersApps/components/EmbeddedApp';
import { useStoreInfo } from 'domains/PartnersApps/hooks';
import { DisabledStoreContent, HandoffStore } from './components';
import useReviveStore from '../../hooks/useReviveStore';
import { trackingBillingReactivateClick } from '../../tracking';
import './CanceledStorePage.scss';

function CanceledStorePage() {
  const { hideSideBar, hideNavTabs, showNavTabs } = useNavTabs();
  const { pathname } = useNavegate();
  const { canReactivateWithoutPayment, status: statusStoreChurnedStatus } =
    useStoreChurnedStatus();
  const { goTo } = useNavegate();
  const { handleReviveStore, isLoading: isLoadingReviveStore } =
    useReviveStore();
  const logout = useLogout();
  const isMobileDevice = useIsMobileDevice();
  const { getNewAdminLink } = useAdminLinks();
  const {
    isDevelopmentStore,
    status: statusDevelopmentStoreHistory,
    fetchDevelopmentStoreHistory,
  } = useDevelopmentStoreHistory();
  const { isLoading } = combineStatus(
    statusStoreChurnedStatus,
    statusDevelopmentStoreHistory,
  );

  useLayoutEffect(() => {
    hideSideBar();
    hideNavTabs();

    return () => {
      showNavTabs();
    };
  }, [hideSideBar, hideNavTabs, showNavTabs]);

  useEffect(() => {
    fetchDevelopmentStoreHistory();
  }, [fetchDevelopmentStoreHistory]);

  const handleRecoverStore = async () => {
    trackingBillingReactivateClick(pathname);
    if (canReactivateWithoutPayment) {
      await handleReviveStore();
    } else {
      if (isMobileDevice) {
        openWindow(
          getNewAdminLink(CHECKOUT_ROUTES.plansAndSubscriptions),
          true,
        );
      } else {
        goTo(CHECKOUT_ROUTES.plansAndSubscriptions);
      }
    }
  };

  const { hasFirstPayment } = useStoreInfo();
  const { storeStatus } = useStoreStatus();

  if (isLoading) {
    return <AppLoading />;
  }

  if (!hasFirstPayment && storeStatus === 'store_down' && isDevelopmentStore) {
    return <HandoffStore handleRecoverStore={handleRecoverStore} />;
  }

  return (
    <div className="stratus--canceled-store-page">
      <IonPageStratus>
        <DisabledStoreContent
          handleRecoverStore={handleRecoverStore}
          logout={logout}
          isLoadingRecoverStore={isLoadingReviveStore}
        />
      </IonPageStratus>
    </div>
  );
}

export default CanceledStorePage;
